import { Card, Typography, Form, Input, Button, Space, message, Descriptions } from 'antd'
import { UserOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { UserService } from '../../../Services/Manage/UserService'
import useNotification from 'antd/es/notification/useNotification'

const ProfilePage = () => {
    const [form] = Form.useForm()
    const [loading, setLoading] = React.useState(false)
    const [notification, noitcons] = useNotification();
    const [uid, setUid] = useState('');

    const ome_user = JSON.parse(localStorage.getItem("ome_user"));

    React.useEffect(() => {
        if (ome_user) {
            setUid(ome_user.uid)
            form.setFieldsValue({
                uid: ome_user.uid,
                name: ome_user.name,
                email: ome_user.email,
                phone: ome_user.phone,
            });
        }
    }, [ome_user, form]);

    const onFinish = async (values) => {
        try {
            console.log('Form values:', values)
            const req = await UserService.updateUsers(values, uid)

            if (req.status) {
                notification.success({
                    message: 'Profile Updated',
                    description: 'User profile details updated successfully',
                })

                if (req.updatedDetails && req.updatedDetails.length > 0) {
                    localStorage.setItem(
                        "ome_user",
                        JSON.stringify(req.updatedDetails[0])
                    );
                }

            } else {
                notification.success({
                    message: 'Something went wrong!',
                    description: req.message,
                })
            }


        } catch (error) {
            message.error('Failed to update profile')
        }
    }



    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                width: '100%',
                padding: 24,
            }}
        >
            {noitcons}
            <Card
                size='large'
                title={<Typography.Title level={4} style={{ margin: 0 }}>Profile</Typography.Title>}
                style={{ maxWidth: 600 }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        label="UID"
                        name="uid"

                    >
                        <Input
                            prefix={<UserOutlined />}
                            readOnly
                            placeholder="Enter your name"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            { required: true, message: 'Please input your name!' },
                            { min: 2, message: 'Name must be at least 2 characters' }
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="Enter your name"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please input your email!' },
                            { type: 'email', message: 'Please enter a valid email!' }
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder="Enter your email"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[
                            { required: true, message: 'Please input your phone number!' },
                            {
                                pattern: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
                                message: 'Please enter a valid phone number!'
                            }
                        ]}
                    >
                        <Input
                            prefix={<PhoneOutlined />}
                            placeholder="Enter your phone number"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Space>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                size="large"
                                block
                            >
                                Update Profile
                            </Button>

                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default ProfilePage